import { createContext, useContext, useReducer, ReactNode, Dispatch } from 'react';

export type PackageFilterType = 'received' | 'consolidated' | 'shipped' | 'all';

interface PackageFilterState {
    statusFilter: PackageFilterType;
}

type PackageFilterAction =
    | { type: 'SET_STATUS_FILTER'; payload: PackageFilterType };

const initialState: PackageFilterState = {
    statusFilter: 'received',
};

function packageFilterReducer(state: PackageFilterState, action: PackageFilterAction): PackageFilterState {
    switch (action.type) {
        case 'SET_STATUS_FILTER':
            return { ...state, statusFilter: action.payload };
        default:
            return state;
    }
}

const PackageFilterContext = createContext<{
    state: PackageFilterState;
    dispatch: Dispatch<PackageFilterAction>;
} | undefined>(undefined);

export const PackageFilterProvider = ({ children }: { children: ReactNode }) => {
    const [state, dispatch] = useReducer(packageFilterReducer, initialState);
    return (
        <PackageFilterContext.Provider value={{ state, dispatch }}>
            {children}
        </PackageFilterContext.Provider>
    );
};

export function usePackageFilterContext() {
    const context = useContext(PackageFilterContext);
    if (!context) {
        throw new Error('usePackageFilterContext must be used within a PackageFilterProvider');
    }
    return context;
}
